import {Directive, ElementRef, OnInit} from "@angular/core";

@Directive({
    selector: "[autofocus]",
    standalone: false
})
export class AutoFocusDirective implements OnInit {
	constructor(private el: ElementRef) {
	}

	ngOnInit() {
		window.setTimeout(() => {
			this.el.nativeElement.focus();
		});
	}
}
